import React from 'react';
import { BookOpen, Moon, RefreshCw } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
const steps = [{
  icon: BookOpen,
  title: 'Read the Manual',
  description: "Understand the biological 'switches' that control your stress hormones."
}, {
  icon: Moon,
  title: 'Apply the Protocol',
  description: 'Follow the 7-minute evening routine to activate your Vagal Brake.'
}, {
  icon: RefreshCw,
  title: 'Reset Your Metabolism',
  description: 'Watch the midsection inflammation drop as your body finally enters deep, restorative sleep.'
}];
export function HowItWorks() {
  return <section className="py-10 bg-slate-800/30 border-y border-slate-800" data-id="element-494">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-495">
        <ScrollFadeIn data-id="element-496">
          <div className="text-center mb-16" data-id="element-497">
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50 mb-4" data-id="element-498">
              How It Works
            </h2>
            <p className="text-lg text-slate-400" data-id="element-499">
              A simple, repeatable process to reclaim your biology.
            </p>
          </div>
        </ScrollFadeIn>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-500">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-slate-700 z-0" data-id="element-501" />

          {steps.map((step, index) => {
          const Icon = step.icon;
          return <ScrollFadeIn key={index} delay={index * 0.2} className="relative z-10" data-id="element-502">
                <div className="flex flex-col items-center text-center" data-id="element-503">
                  <div className="w-24 h-24 rounded-full bg-slate-900 border-4 border-slate-800 flex items-center justify-center mb-6 shadow-xl" data-id="element-504">
                    <Icon className="w-10 h-10 text-amber-500" data-id="element-505" />
                  </div>
                  <h3 className="text-xl font-medium text-slate-50 mb-3" data-id="element-506">
                    Step {index + 1}: {step.title}
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-507">
                    {step.description}
                  </p>
                </div>
              </ScrollFadeIn>;
        })}
        </div>
      </div>
    </section>;
}